import { render, staticRenderFns } from "./productInput.vue?vue&type=template&id=42c09696"
import script from "./productInput.vue?vue&type=script&lang=js"
export * from "./productInput.vue?vue&type=script&lang=js"
import style0 from "./productInput.vue?vue&type=style&index=0&id=42c09696&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports